<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse"
        [fullScreen]="true">
        <p style="color: black"> กำลังโหลดข้อมูล... </p>
    </ngx-spinner>
    <div class="container-fluid">


        <div class="card">
            <div class="row justify-content-md-center align-items-center">
                <div class="col-md-auto" style="text-align: center;">
                    <h4>รายการขอเบิกปัจจัยการผลิต ปี {{year_id.substr(0,2)}}/{{year_id.substr(2,2)}} โซน {{zone}}</h4>
                </div>
                <div class="col-md-auto">
                    <table class="example-full-width" style="width: 100%">
                        <tr style="text-align:center">
                            <td>
                                <mat-form-field appearance="fill">
                                    <mat-label>ช่วงวันที่จะขอ</mat-label>
                                    <mat-date-range-input [rangePicker]="picker" disabled>
                                        <input matStartDate [(ngModel)]="inDate1" placeholder="วันที่เริ่มต้น">
                                        <input matEndDate [(ngModel)]="inDate2" placeholder="วันที่สุดท้าย">
                                    </mat-date-range-input>

                                    <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-hint><mat-label>ช่วงวันที่เลือก {{inDate1|adtob}} -
                                            {{inDate2|adtob}}</mat-label></mat-hint>
                                </mat-form-field>
                            </td>
                            <td>
                                <button mat-raised-button color="primary" (click)="Loaddata_api();">
                                    <i class="fas fa-check"></i>ตกลง</button>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="col-md-auto">
                    <!-- Nav tabs -->
                    <ul class="nav nav-pills mb-3 d-flex align-items-center" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="btn btn-outline-dark" [ngClass]="{'active':id == 1}"
                                (click)="id=1;">เบิกที่สต็อคโรงงาน
                                <span class="badge badge-pill badge-success">
                                    {{databystock.length}} </span></a>
                        </li>
                        <li class="nav-item">
                            <a class="btn btn-outline-dark" [ngClass]="{'active':id == 2}" (click)="id=2;">ที่สต็อคโซน
                                {{zone}}
                                <span class="badge badge-pill badge-primary">
                                    {{databyzone.length}} </span></a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="btn btn-outline-dark" [ngClass]="{'active':id == 3}" (click)="id=3;">ชาวไร่โซน
                                {{zone}} ไปเบิกที่โซนอื่น
                                <span class="badge badge-pill badge-warning">
                                    {{dataoutzone.length}} </span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card card-success" [hidden]="id!==1">
            <div class="card-header">
                <h3 class="card-title"> <i class="fas fa-home"></i> รายการขอเบิกปัจจัยการผลิต ปี
                    {{year_id.substr(0,2)}}/{{year_id.substr(2,2)}} โซน {{zone}} เบิกที่สต็อคโรงงาน
                    | <span class="badge badge-pill badge-primary"> {{databystock.length}} </span> รายการ</h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                    </button>
                </div>
                <!-- /.card-tools -->
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="table-responsive-sm">
                    <table #onstock class="table table-hover table-head-fixed">
                        <thead class="table-success">
                            <tr class="headText text-primary" style="text-align:center">
                                <th>เลขที่คำขอ</th>
                                <th>วันเวลาที่ขอ</th>
                                <th>ชื่อ-นามสกุล</th>
                                <th>เลขแปลง</th>
                                <th>รายการ</th>
                                <th>Stock</th>
                                <th>ราคา</th>
                                <th></th>
                                <th>เบิกแล้ว</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let element of databystock">
                                <td> {{element.docid}} <b *ngIf="element.take_method == 1"
                                        style="color: red;">(เงินสด)</b>
                                </td>
                                <td>{{element.datepost | date:'YYYY/MM/dd'}}</td>
                                <td>{{element.fmname}}</td>
                                <td>{{element.intlandno}}</td>
                                <td style="text-align:left">
                                    <mat-label *ngIf="element.amt1>0">- {{element.desc1}} *
                                        <span class="badge badge-pill badge-primary"> {{element.amt1}} </span>
                                    </mat-label>
                                    <mat-label *ngIf="element.amt2>0">, {{element.desc2}} *
                                        <span class="badge badge-pill badge-primary"> {{element.amt2}} </span>
                                    </mat-label>
                                    <mat-label *ngIf="element.amt4>0">, {{element.desc4}} *
                                        <span class="badge badge-pill badge-primary"> {{element.amt4}} </span>
                                    </mat-label>
                                    <mat-label *ngIf="element.amt3>0">, {{element.desc3}} *
                                        <span class="badge badge-pill badge-primary"> {{element.amt3}} </span>
                                    </mat-label>
                                    <mat-label *ngIf="element.amt5>0">, {{element.desc5}} *
                                        <span class="badge badge-pill badge-primary"> {{element.amt5}} </span>
                                    </mat-label>-
                                </td>
                                <td>{{element.Stockname}}</td>
                                <td style="text-align:right">{{element.money_amt | number}}</td>
                                <td>
                                    <button mat-button [matMenuTriggerFor]="menu">
                                        <mat-icon>more_vert</mat-icon></button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item>
                                            <a [routerLink]="['/docfertilizer/'+year_id+'/'+element.fmcode_b1+'/'+element.docid+'/0']"
                                                routerLinkActive="active" target="_blank">
                                                <i class="fas fa-print"></i> พิมพ์</a>
                                        </button>
                                        <button mat-menu-item>
                                            <a [routerLink]="['/docfertilizer/'+year_id+'/'+element.fmcode_b1+'/'+element.docid+'/1']"
                                                routerLinkActive="active" target="_blank">
                                                <i class="fas fa-print"></i> พิมพ์ซ้ำ
                                            </a>
                                        </button>
                                        <button mat-menu-item *ngIf="element.sccenter !== '1'"
                                            (click)="cancledata(element)">
                                            <i class="fas fa-comment-slash"></i> ยกเลิก
                                        </button>
                                    </mat-menu>
                                </td>
                                <td style="text-align:center">
                                    <button [disabled]="element.doc_print == 1" class="btn btn-sm btn-info"
                                        (click)="confirmused(element);">
                                        <i class="fas fa-check-circle"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- /.card-body -->
        </div>
        <!-- เบิกโรงงาน -->
        <!-- เบิกในโซน -->
        <div class="card card-primary" [hidden]="id!==2">
            <div class="card-header">
                <h3 class="card-title"> <i class="fas fa-chalkboard-teacher"></i> รายการขอเบิกปัจจัยการผลิต ปี
                    {{year_id.substr(0,2)}}/{{year_id.substr(2,2)}} ที่สต็อคโซน {{zone}} สำหรับพิมพ์ใบจ่ายปุ๋ย
                    | <span class="badge badge-pill badge-warning"> {{databyzone.length}} </span> รายการ</h3>

                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                    </button>
                </div>
                <!-- /.card-tools -->
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <table class="table table-hover table-head-fixed text-nowrap" #inzone>
                    <thead class="table-primary">
                        <tr class="headText text-primary" style="text-align:center">
                            <th>เลขที่คำขอ</th>
                            <th>วันเวลาที่ขอ</th>
                            <th>ชื่อ - นามสกุล</th>
                            <th>เลขแปลง</th>
                            <th>รายการ</th>
                            <th>Stock</th>
                            <th>ราคา</th>
                            <th></th>
                            <th>เบิกแล้ว</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of databyzone">
                            <td> {{element.docid}} <b *ngIf="element.take_method == 1" style="color: red;">(เงินสด)</b>
                            </td>
                            <td>{{element.datepost | date:'YYYY/MM/dd'}}</td>
                            <td>{{element.fmname}}</td>
                            <td>{{element.intlandno}}</td>
                            <td style="text-align:left">
                                <mat-label *ngIf="element.amt1>0">- {{element.desc1}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt1}} </span> </mat-label>
                                <mat-label *ngIf="element.amt2>0">, {{element.desc2}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt2}} </span> </mat-label>
                                <mat-label *ngIf="element.amt4>0">, {{element.desc4}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt4}} </span> </mat-label>
                                <mat-label *ngIf="element.amt3>0">, {{element.desc3}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt3}} </span> </mat-label>
                                <mat-label *ngIf="element.amt5>0">, {{element.desc5}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt5}} </span> </mat-label>-
                            </td>
                            <td>{{element.Stockname}}</td>
                            <td style="text-align:right">{{element.money_amt | number}}</td>
                            <td>
                                <button mat-button [matMenuTriggerFor]="menu"> <mat-icon>more_vert</mat-icon></button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item>
                                        <a [routerLink]="['/docfertilizer/'+year_id+'/'+element.fmcode_b1+'/'+element.docid+'/0']"
                                            routerLinkActive="active" target="_blank">
                                            <i class="fas fa-print"></i> พิมพ์</a>
                                    </button>
                                    <button mat-menu-item>
                                        <a [routerLink]="['/docfertilizer/'+year_id+'/'+element.fmcode_b1+'/'+element.docid+'/1']"
                                            routerLinkActive="active" target="_blank">
                                            <i class="fas fa-print"></i> พิมพ์ซ้ำ
                                        </a>
                                    </button>
                                    <button mat-menu-item *ngIf="element.sccenter !== '1'"
                                        (click)="cancledata(element)">

                                        <i class="fas fa-comment-slash"></i> ยกเลิก
                                    </button>
                                </mat-menu>
                            </td>
                            <td style="text-align:center">
                                <button [disabled]="element.doc_print == 1" class="btn btn-sm btn-info"
                                    (click)="confirmused(element);">
                                    <i class="fas fa-check-circle"></i>
                                </button>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- /.card-body -->
        </div>
        <!-- เบิกในโซน -->

        <!-- เบิกนอกโซน -->
        <div class="card card-warning" [hidden]="id!==3">
            <div class="card-header">
                <h3 class="card-title"> <i class="fas fa-chalkboard"></i> รายการขอเบิกปัจจัยการผลิต ปี
                    {{year_id.substr(0,2)}}/{{year_id.substr(2,2)}} ชาวไร่โซน {{zone}} ไปเบิกปุ๋ยที่โซนอื่น
                    | <span class="badge badge-pill badge-primary"> {{dataoutzone.length}} </span> รายการ</h3>

                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                    </button>
                </div>
                <!-- /.card-tools -->
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <table class="table table-hover table-head-fixed text-nowrap" #outzone>
                    <thead class="table-warning">
                        <tr class="headText text-primary" style="text-align:center">
                            <th>เลขที่คำขอ</th>
                            <th>วันเวลาที่ขอ</th>
                            <th>ชื่อ - นามสกุล</th>
                            <th>เลขแปลง</th>
                            <th>รายการ</th>
                            <th>Stock</th>
                            <th>ราคา</th>
                            <th></th>
                            <th>เบิกแล้ว</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of dataoutzone">
                            <td>{{element.docid}} <b *ngIf="element.take_method == 1" style="color: red;">(เงินสด)</b>
                            </td>
                            <td>{{element.datepost | date:'YYYY/MM/dd'}}</td>
                            <td>{{element.fmname}}</td>
                            <td>{{element.intlandno}}</td>
                            <td style="text-align:left">
                                <mat-label *ngIf="element.amt1>0">- {{element.desc1}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt1}} </span> </mat-label>
                                <mat-label *ngIf="element.amt2>0">, {{element.desc2}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt2}} </span> </mat-label>
                                <mat-label *ngIf="element.amt4>0">, {{element.desc4}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt4}} </span> </mat-label>
                                <mat-label *ngIf="element.amt3>0">, {{element.desc3}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt3}} </span> </mat-label>
                                <mat-label *ngIf="element.amt5>0">, {{element.desc5}} *
                                    <span class="badge badge-pill badge-primary"> {{element.amt5}} </span> </mat-label>-
                            </td>
                            <td>{{element.Stockname}}</td>
                            <td style="text-align:right">{{element.money_amt | number}}</td>
                            <td>
                                <button mat-button [matMenuTriggerFor]="menu"> <mat-icon>more_vert</mat-icon></button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item>
                                        <a [routerLink]="['/docfertilizer/'+year_id+'/'+element.fmcode_b1+'/'+element.docid+'/0']"
                                            routerLinkActive="active" target="_blank">
                                            <i class="fas fa-print"></i> พิมพ์</a>

                                    </button>
                                    <button mat-menu-item>
                                        <a [routerLink]="['/docfertilizer/'+year_id+'/'+element.fmcode_b1+'/'+element.docid+'/1']"
                                            routerLinkActive="active" target="_blank">
                                            <i class="fas fa-print"></i> พิมพ์ซ้ำ
                                        </a>
                                    </button>
                                    <button mat-menu-item *ngIf="element.sccenter !== '1'"
                                        (click)="cancledata(element)">

                                        <i class="fas fa-comment-slash"></i> ยกเลิก
                                    </button>
                                </mat-menu>
                            </td>
                            <td style="text-align:center">
                                <button [disabled]="element.doc_print == 1" class="btn btn-sm btn-info"
                                    (click)="confirmused(element);">
                                    <i class="fas fa-check-circle"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- /.card-body -->
        </div>
        <!-- เบิกนอกโซน -->
    </div>

</div>
<app-footer></app-footer>